import React, { useEffect } from 'react';
import 'ol/ol.css';
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import VectorLayer from 'ol/layer/Vector';
import { WKT } from 'ol/format';
import VectorSource from 'ol/source/Vector';
import { Fill, Stroke, Style } from 'ol/style';
import { MapData } from '../../types/mapInterfaces'

interface ChildComponentProps {
    data: MapData;
}

export const MapComponent: React.FC<ChildComponentProps> = ({ data }) => {

    useEffect(() => {
        // Create VectorSource and VectorLayer to add polygons to map
        let vSource = new VectorSource({
            features: [],
        });

        let vectorLayer = new VectorLayer({
            source: vSource,
            style: new Style({
                stroke: new Stroke({
                    color: 'blue',
                    width: 3,
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 255, 0.1)',
                }),
            }),
        })

        // Create map
        const map = new Map({
            target: 'map',
            layers: [
                new TileLayer({
                    source: new OSM(),
                }),
                vectorLayer,
            ],
            view: new View({
                center: [0, 0],
                zoom: 2,
            }),
        });
        
        // Add polygons to map
        data.polygons?.forEach((polygon, index) => {

            let wktPolygon = polygon.wkt

            if(!wktPolygon) {
                console.warn("No WKT polygon found in data");
                return;
            }
            // Add polygon to map
            let format = new WKT();
            let feature = format.readFeature(wktPolygon);

            vSource.addFeature(feature as never); // TODO: Fix this type error

            // Zoom to polygon
            if(index === 0) {
                let extent = feature.getGeometry()?.getExtent();
                if(extent) {
                    map.getView().fit(extent, {
                         duration: 2000,
                        padding: [25, 25, 25, 25],
                    })
                }
            }
        })
     
        return () => {
            // Clean up the map when the component is unmounted
            map.dispose();
        };
    }, []); // Empty dependency array ensures useEffect runs only once

    return <div id="map" style={{ width: '100%', height: '100%' }}></div>;
};

export default MapComponent;